/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [获取ERP菜单内容↗](http://yapi.yishou.com/project/128/interface/api/29999) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getErpMenu`
 */
const getErpMenuRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/getErpMenu",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                id: { type: "number" },
                pid: { type: "number" },
                label: { type: "string" },
                link: { type: "string" },
                mca: { type: "string" },
                children: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number" },
                            pid: { type: "number" },
                            label: { type: "string" },
                            link: { type: "string" },
                            mca: { type: "string" },
                            children: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        id: { type: "number" },
                                        pid: { type: "number" },
                                        label: { type: "string" },
                                        link: { type: "string" },
                                        mca: { type: "string" },
                                    },
                                    required: ["id", "pid", "label", "link", "mca"],
                                },
                            },
                        },
                        required: ["id", "pid", "label", "link", "mca"],
                    },
                },
            },
            required: ["id", "pid", "label", "link", "mca"],
        },
    },
    requestFunctionName: "getErpMenu",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取ERP菜单内容↗](http://yapi.yishou.com/project/128/interface/api/29999) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getErpMenu`
 */
export const getErpMenu = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getErpMenuRequestConfig, requestData), ...args);
};
getErpMenu.requestConfig = getErpMenuRequestConfig;
/**
 * 接口 [获取采购组下的采购员↗](http://yapi.yishou.com/project/128/interface/api/32002) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getPgMember`
 */
const getPgMemberRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/getPgMember",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["pgid"], properties: { pgid: { type: "string" } } },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                label: { type: "string", description: "采购员名字" },
                value: { type: "string", description: "采购员id" },
            },
            required: ["label", "value"],
        },
    },
    requestFunctionName: "getPgMember",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取采购组下的采购员↗](http://yapi.yishou.com/project/128/interface/api/32002) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getPgMember`
 */
export const getPgMember = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getPgMemberRequestConfig, requestData), ...args);
};
getPgMember.requestConfig = getPgMemberRequestConfig;
/**
 * 接口 [一级市场↗](http://yapi.yishou.com/project/128/interface/api/33289) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getFirstMarketList`
 */
const getFirstMarketListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/getFirstMarketList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: { market_id: { type: "string" }, market_name: { type: "string" } },
            required: ["market_id", "market_name"],
        },
    },
    requestFunctionName: "getFirstMarketList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [一级市场↗](http://yapi.yishou.com/project/128/interface/api/33289) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getFirstMarketList`
 */
export const getFirstMarketList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getFirstMarketListRequestConfig, requestData), ...args);
};
getFirstMarketList.requestConfig = getFirstMarketListRequestConfig;
/**
 * 接口 [二级子市场↗](http://yapi.yishou.com/project/128/interface/api/33290) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getSubMarketList`
 */
const getSubMarketListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/getSubMarketList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [],
        properties: { parent_id: { type: "string", description: "父级市场id" } },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: { market_id: { type: "string" }, market_name: { type: "string" } },
            required: ["market_id", "market_name"],
        },
    },
    requestFunctionName: "getSubMarketList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [二级子市场↗](http://yapi.yishou.com/project/128/interface/api/33290) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getSubMarketList`
 */
export const getSubMarketList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getSubMarketListRequestConfig, requestData), ...args);
};
getSubMarketList.requestConfig = getSubMarketListRequestConfig;
/**
 * 接口 [获取采购组↗](http://yapi.yishou.com/project/128/interface/api/33292) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/Common/selectPg`
 */
const selectPgRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/selectPg",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                label: { type: "string", description: "采购组名称" },
                value: { type: "string", description: "采购组ID" },
            },
            required: ["label", "value"],
        },
    },
    requestFunctionName: "selectPg",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取采购组↗](http://yapi.yishou.com/project/128/interface/api/33292) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/Common/selectPg`
 */
export const selectPg = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(selectPgRequestConfig, requestData), ...args);
};
selectPg.requestConfig = selectPgRequestConfig;
/**
 * 接口 [获取市场列表↗](http://yapi.yishou.com/project/128/interface/api/34034) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/Common/getMarketList`
 */
const getMarketListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/getMarketList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                key: { type: "string" },
                label: { type: "string" },
                show_brand: { type: "string" },
                children: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: { key: { type: "string" }, label: { type: "string" }, show_brand: { type: "string" } },
                        required: ["key", "label", "show_brand"],
                    },
                },
            },
            required: ["key", "label", "show_brand", "children"],
        },
    },
    requestFunctionName: "getMarketList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取市场列表↗](http://yapi.yishou.com/project/128/interface/api/34034) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/Common/getMarketList`
 */
export const getMarketList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getMarketListRequestConfig, requestData), ...args);
};
getMarketList.requestConfig = getMarketListRequestConfig;
/**
 * 接口 [获取供应商城市↗](http://yapi.yishou.com/project/128/interface/api/34054) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/Common/getCityList`
 */
const getCityListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/getCityList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: { key: { type: "number" }, label: { type: "string" } },
            required: ["key", "label"],
        },
    },
    requestFunctionName: "getCityList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取供应商城市↗](http://yapi.yishou.com/project/128/interface/api/34054) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/Common/getCityList`
 */
export const getCityList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getCityListRequestConfig, requestData), ...args);
};
getCityList.requestConfig = getCityListRequestConfig;
/**
 * 接口 [获取供应商列表↗](http://yapi.yishou.com/project/128/interface/api/34056) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/fetchSupplyBySearch`
 */
const fetchSupplyBySearchRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/fetchSupplyBySearch",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["supply_name"], properties: { supply_name: { type: "string" } } },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                label: { type: "string", description: "供应商名称" },
                value: { type: "string", description: "供应商id" },
            },
        },
    },
    requestFunctionName: "fetchSupplyBySearch",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取供应商列表↗](http://yapi.yishou.com/project/128/interface/api/34056) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/fetchSupplyBySearch`
 */
export const fetchSupplyBySearch = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(fetchSupplyBySearchRequestConfig, requestData), ...args);
};
fetchSupplyBySearch.requestConfig = fetchSupplyBySearchRequestConfig;
/**
 * 接口 [供应商搜索↗](http://yapi.yishou.com/project/128/interface/api/34534) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/fetchSupplyBySearchByPage`
 */
const fetchSupplyBySearchByPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/fetchSupplyBySearchByPage",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_name", "page", "page_size"],
        properties: {
            supply_name: { type: "string", description: "供应商名称" },
            page: { type: "string", description: "页码" },
            page_size: { type: "string", description: "大小" },
        },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                label: { type: "string", description: '"-1-147-香.香"' },
                value: { type: "string", description: '"15117"' },
            },
            additionalProperties: false,
        },
        description: '[{"label":"-1-147-香.香","value":"15117"},{"label":"1-1305-香姿菲怡","value":"15732"},{"label":"1-1377-百香姿","value":"15419"},{"label":"1-7栋A08-香港顺子","value":"15857"},{"label":"1-A-昇创A29至30-香港顺子","value":"14573"},{"label":"1-B-61-香伊人服饰","value":"14347"},{"label":"1-C318-香米耶","value":"10306"},{"label":"1-世纪广场35-香港顺子","value":"14494"},{"label":"1-二区香港街1410号-欧时尚","value":"11103"},{"label":"1-工贸二区香港街1291号-一木","value":"11089"},{"label":"1-桐乡市齐源路18号中茂大厦-香港安妮莱斯时装有限公司","value":"13932"},{"label":"10-137-香域服饰","value":"15599"},{"label":"2-2073A香港伊人世家","value":"8459"},{"label":"2-2260-香域","value":"15770"},{"label":"2-2301-江南衣香","value":"15657"},{"label":"2-4B21-影香艺","value":"11607"},{"label":"2-B-106栋二楼B32-金典香衣","value":"13012"},{"label":"2-B-164-卜香牛仔","value":"14207"},{"label":"2-西区2566-帛香坊","value":"13897"},{"label":"3-101-弥香","value":"7476"}]',
    },
    requestFunctionName: "fetchSupplyBySearchByPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [供应商搜索↗](http://yapi.yishou.com/project/128/interface/api/34534) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/fetchSupplyBySearchByPage`
 */
export const fetchSupplyBySearchByPage = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(fetchSupplyBySearchByPageRequestConfig, requestData), ...args);
};
fetchSupplyBySearchByPage.requestConfig = fetchSupplyBySearchByPageRequestConfig;
/**
 * 接口 [获取省↗](http://yapi.yishou.com/project/128/interface/api/34581) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/common/getProvince`
 */
const getProvinceRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/common/getProvince",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "省ID" },
                        pid: { type: "string" },
                        name: { type: "string", description: "省" },
                    },
                    required: ["id", "pid", "name"],
                },
            },
        },
    },
    requestFunctionName: "getProvince",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取省↗](http://yapi.yishou.com/project/128/interface/api/34581) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/common/getProvince`
 */
export const getProvince = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getProvinceRequestConfig, requestData), ...args);
};
getProvince.requestConfig = getProvinceRequestConfig;
/**
 * 接口 [获取地级市↗](http://yapi.yishou.com/project/128/interface/api/34582) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/common/getCity`
 */
const getCityRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/common/getCity",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["province"],
        properties: { province: { type: "string", description: "省ID" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "市ID" },
                        pid: { type: "string", description: "省ID" },
                        name: { type: "string", description: "市名称" },
                    },
                    required: ["id", "pid", "name"],
                },
            },
        },
    },
    requestFunctionName: "getCity",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取地级市↗](http://yapi.yishou.com/project/128/interface/api/34582) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/common/getCity`
 */
export const getCity = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getCityRequestConfig, requestData), ...args);
};
getCity.requestConfig = getCityRequestConfig;
/**
 * 接口 [获取地级县↗](http://yapi.yishou.com/project/128/interface/api/34583) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/common/getDistrict`
 */
const getDistrictRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/common/getDistrict",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["city"],
        properties: { city: { type: "string", description: "市Id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "县ID" },
                        pid: { type: "string", description: "市ID" },
                        name: { type: "string", description: "县名称" },
                    },
                    required: ["id", "pid", "name"],
                },
            },
        },
    },
    requestFunctionName: "getDistrict",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取地级县↗](http://yapi.yishou.com/project/128/interface/api/34583) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/common/getDistrict`
 */
export const getDistrict = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getDistrictRequestConfig, requestData), ...args);
};
getDistrict.requestConfig = getDistrictRequestConfig;
/**
 * 接口 [获取快递公司信息↗](http://yapi.yishou.com/project/128/interface/api/34621) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/common/getShippingCompany`
 */
const getShippingCompanyRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/common/getShippingCompany",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                cpid: { type: "string" },
                shipping_company: { type: "string", description: "快递公司" },
                shipping_name: { type: "string" },
                kdniao: { type: "string" },
                cniao: { type: "string" },
            },
            required: ["cpid", "shipping_company", "shipping_name", "kdniao", "cniao"],
        },
    },
    requestFunctionName: "getShippingCompany",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取快递公司信息↗](http://yapi.yishou.com/project/128/interface/api/34621) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/common/getShippingCompany`
 */
export const getShippingCompany = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getShippingCompanyRequestConfig, requestData), ...args);
};
getShippingCompany.requestConfig = getShippingCompanyRequestConfig;
/**
 * 接口 [获取快递网点↗](http://yapi.yishou.com/project/128/interface/api/34622) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/common/getShippingSender`
 */
const getShippingSenderRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/common/getShippingSender",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["shipping_company"],
        properties: { shipping_company: { type: "string", description: "快递公司名称" } },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: { shipping_company: { type: "string" }, sender: { type: "string" }, sender_id: { type: "string" } },
            required: ["shipping_company", "sender", "sender_id"],
        },
    },
    requestFunctionName: "getShippingSender",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取快递网点↗](http://yapi.yishou.com/project/128/interface/api/34622) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/common/getShippingSender`
 */
export const getShippingSender = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getShippingSenderRequestConfig, requestData), ...args);
};
getShippingSender.requestConfig = getShippingSenderRequestConfig;
/**
 * 接口 [获取采购员信息↗](http://yapi.yishou.com/project/128/interface/api/35284) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getPurchaseMember`
 */
const getPurchaseMemberRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Common/getPurchaseMember",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [],
        properties: {
            status: { type: "string", description: "状态{1:启用,0:全部}" },
            pgid: { type: "string", description: "采购组ID ，不传则查询全部" },
        },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                label: { type: "string", description: "代采员ID" },
                value: { type: "string", description: "代采员姓名" },
            },
            required: ["label", "value"],
        },
    },
    requestFunctionName: "getPurchaseMember",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取采购员信息↗](http://yapi.yishou.com/project/128/interface/api/35284) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `POST /erp/Common/getPurchaseMember`
 */
export const getPurchaseMember = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getPurchaseMemberRequestConfig, requestData), ...args);
};
getPurchaseMember.requestConfig = getPurchaseMemberRequestConfig;
/**
 * 接口 [开户银行列表↗](http://yapi.yishou.com/project/128/interface/api/38591) 的 **请求配置**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/common/getBankList`
 */
const getBankListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/common/getBankList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: { key: { type: "string" }, value: { type: "string" } },
            required: ["key", "value"],
        },
    },
    requestFunctionName: "getBankList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [开户银行列表↗](http://yapi.yishou.com/project/128/interface/api/38591) 的 **请求函数**
 *
 * @分类 [公共模块↗](http://yapi.yishou.com/project/128/interface/api/cat_2302)
 * @请求头 `GET /erp/common/getBankList`
 */
export const getBankList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getBankListRequestConfig, requestData), ...args);
};
getBankList.requestConfig = getBankListRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/common2302.js